import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import '@/styles/pages/error.css'

function Unauthorized(): React.JSX.Element {
  const { isAuthenticated } = useAuth()

  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-code">401</div>
        <h1 className="error-title">Unauthorized Access</h1>
        <p className="error-message">
          You need to be logged in to access this page. Please log in
          with your credentials.
        </p>

        <div className="error-actions">
          {!isAuthenticated && (
            <Link to="/login" className="btn btn-primary">
              Go to Login
            </Link>
          )}
          <Link to="/" className="btn btn-secondary">
            Back to Home
          </Link>
        </div>

        <div className="error-help">
          <p>
            Don't have an account?{' '}
            <Link to="/register">Register here</Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default Unauthorized
